import styled from "styled-components";

const HomeStyles = styled.div`
  .top-section {
    background: linear-gradient(
        to top,
        rgba(35, 31, 32, 1) 0%,
        rgba(35, 31, 32, 0) 40%
      ),
      url("https://res.cloudinary.com/table-sage/image/upload/c_scale,f_auto,q_auto:good,w_2072/v1632735770/ts-homepage/edited-home-banner_kfp1ez.jpg");
    background-size: cover;
    background-position: center;
    height: 400px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 60px 12px 0;
  }

  .intro-text {
    position: relative;
    top: 250px;
    margin: 0 auto;
    height: 100%;
    margin-bottom: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .top-header {
    font-family: var(--header-font);
    color: white;
    font-size: 70px;
    line-height: 78px;
    margin-bottom: 18px;
    width: 95vw;
    max-width: 330px;
  }

  .top-description {
    font-family: var(--body-font);
    font-size: 20px;
    line-height: 28px;
    /* padding-left: 4px; */
    width: 95vw;
    max-width: 330px;
    margin-bottom: 40px;
    color: white;

    /* span {
      //hack to apply background color to individual text lines
      box-shadow: 0 0 0 4px #fff;
      background-color: #fff;
      //fix firefox
      box-decoration-break: clone;
      line-height: 1.1;
      padding: 0 4px 0 4px;
      border: 1px solid white;
    } */
  }

  /* .dine-well,
  .do-good {
    //hack to apply background color to individual text lines
    box-shadow: 0 0 0 8px #fff;
    background-color: #fff;
    //fix firefox
    box-decoration-break: clone;
    line-height: 38px;
    padding-top: 5px;
    border: 1px solid white;
  } */

  .dine-well {
    display: block;
  }

  /*  .do-good {
    line-height: 62px;
  } */

  .phone-screen-container {
    //push down to accommodate dine well do good text pushed down
    margin-top: 260px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }

  .phone-screen {
    position: relative;
    height: 540px;
    width: 275px;
  }

  .phone-bezel-and-vid {
    position: relative;
  }

  .phone-screen-video {
    background-color: var(--off-black);
    height: 510px;
    width: 231px;
    /* border-radius: 20px; */
    position: absolute;
    left: 22px;
    bottom: 20px;
  }

  .second-section {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }

  .graphic-card {
    background-color: var(--off-black);
    padding: 900px 12px 60px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    p {
      color: white;
      font-family: var(--header-font);
      font-weight: normal !important;
      font-size: 28px;
      text-align: center;
      line-height: 36px;
      margin-bottom: 60px;
      padding: 0 8px;
      max-width: 380px;
    }
  }

  .circle-graphic {
    width: 100%;
    max-width: 320px;
    padding: 0 12px;
  }

  .process-card {
    background-color: var(--ts-tan);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 60px 12px;
  }

  .point {
    max-width: 340px;
    opacity: 0;

    h2 {
      font-family: var(--body-font-bold);
      font-size: 42px;
      font-weight: normal;
      line-height: 35px;
      margin-bottom: 12px;
    }

    p {
      font-size: 18px;
      line-height: 26px;
      margin-bottom: 30px;
    }
  }

  #about-process-btn {
    opacity: 0;
  }

  @keyframes fadein {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }

  .animate-text#point-one {
    opacity: 0;
    -webkit-animation: fadein 1s ease forwards;
    -moz-animation: fadein 1s ease forwards;
    -o-animation: fadein 1s ease forwards;
    -ms-animation: fadein 1s ease forwards;
    animation: fadein 1s ease forwards;
  }

  .animate-text#point-two {
    opacity: 0;
    -webkit-animation: fadein 1s ease 1s forwards;
    -moz-animation: fadein 1s ease 1s forwards;
    -o-animation: fadein 1s ease 1s forwards;
    -ms-animation: fadein 1s ease 1s forwards;
    animation: fadein 1s ease 1s forwards;
  }

  .animate-text#point-three {
    opacity: 0;
    -webkit-animation: fadein 1s ease 2s forwards;
    -moz-animation: fadein 1s ease 2s forwards;
    -o-animation: fadein 1s ease 2s forwards;
    -ms-animation: fadein 1s ease 2s forwards;
    animation: fadein 1s ease 2s forwards;
  }

  .animate-text#about-process-btn {
    opacity: 0;
    -webkit-animation: fadein 0.7s ease 3s forwards;
    -moz-animation: fadein 0.7s ease 3s forwards;
    -o-animation: fadein 0.7s ease 3s forwards;
    -ms-animation: fadein 0.7s ease 3s forwards;
    animation: fadein 0.7s ease 3s forwards;
  }

  .third-section {
    height: 80vh;
    min-height: 650px;
    position: relative;

    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
      object-position: 10% center;
    }
  }

  .image-text-box {
    flex-direction: column;
    align-items: center;
    max-width: 470px;
  }

  .text-over-image {
    width: 100%;
    position: absolute;
    height: inherit;
    min-height: 650px;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    text-align: center;
    padding: 40px 14px;

    p {
      margin-bottom: 20px;
      line-height: 35px;
      /* max-width: 320px; */
    }

    span {
      //hack to apply background color to individual text lines
      box-shadow: 0 0 0 4px #fff;
      background-color: #fff;
      //fix firefox
      box-decoration-break: clone;
      line-height: 20px;
      padding: 0 2px 0 4px;
      border: 1px solid white;
    }
  }

  @keyframes hideshow {
    0% {
      opacity: 0.2;
    }
    5% {
      opacity: 1;
    }
    18% {
      opacity: 1;
    }
    20% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }

  #cuisine-icon {
    animation: hideshow 12.5s ease infinite;
  }

  #experience-icon {
    opacity: 0;
    animation: hideshow 12.5s 2.5s ease infinite;
  }

  #story-icon {
    opacity: 0;
    animation: hideshow 12.5s 5s ease infinite;
  }

  #sustainability-icon {
    opacity: 0;
    animation: hideshow 12.5s 7.5s ease infinite;
  }

  #diversity-icon {
    opacity: 0;
    animation: hideshow 12.5s 10s ease infinite;
  }

  .fourth-section {
    display: flex;
    flex-direction: column-reverse;
  }

  .impact-card {
    background-color: #c0c9bd;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 60px 12px;

    h2 {
      font-family: var(--body-font-bold);
      font-weight: normal !important;
      max-width: 320px;
      margin: 0 auto;
      font-size: 22px;
      line-height: 30px;
      margin-bottom: 34px;
      color: black;
    }

    p {
      max-width: 320px;
      margin: 0 auto;
      margin-bottom: 20px;
      color: black;

      &:last-child {
        margin-bottom: 60px;
      }
    }
  }

  .values-card {
    background-color: var(--off-black);
    padding: 60px 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    p {
      color: white;
      font-family: var(--header-font);
      font-weight: normal !important;
      font-size: 28px;
      text-align: center;
      line-height: 36px;
      margin-bottom: 60px;
      padding: 0 8px;
      max-width: 380px;
    }

    &__item {
      position: relative;
      height: 232px;
    }

    &__item > svg {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .articles-section {
    content: "";
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 60px 12px 65px;

    h2 {
      font-family: var(--body-font-bold);
      font-weight: normal !important;
      max-width: 280px;
      margin: 0 auto;
      font-size: 22px;
      line-height: 30px;
      margin-bottom: 20px;
      color: black;
    }

    p {
      max-width: 320px;
      margin: 0 auto;
      margin-bottom: 20px;
      color: black;
      margin-bottom: 50px;
    }
  }

  .partner-section {
    background-image: linear-gradient(
      0deg,
      rgba(231, 244, 166, 0.1) 0%,
      rgba(231, 244, 166, 0.52) 71%,
      rgba(231, 244, 166, 0.72) 90%,
      #e7f4a6 99%
    );
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 60px 12px;

    h2 {
      font-family: var(--body-font-bold);
      font-weight: normal !important;
      max-width: 320px;
      margin: 0 auto;
      font-size: 22px;
      line-height: 30px;
      margin-bottom: 30px;
      color: black;
    }

    p {
      max-width: 330px;
      margin: 0 auto;
      margin-bottom: 20px;
      color: black;

      &:last-child {
        margin-bottom: 60px;
      }
    }
  }

  .featured-on {
    padding: 60px 0 80px 0;

    h2 {
      font-family: var(--body-font-bold);
      font-weight: normal !important;
      text-align: center;
      margin: 0 auto;
      font-size: 22px;
      line-height: 30px;
      margin-bottom: 50px;
      color: black;
    }

    &-logo {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      margin-bottom: 44px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .logos {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  #sarah-linda-logo {
    height: 32px;
    width: 88px;
    object-fit: cover;
  }

  #iamsterdam-logo {
    height: 41px;
    width: 111px;
    object-fit: cover;
  }

  #mezpiration-logo {
    height: 49px;
    width: 49px;
    object-fit: cover;
  }

  #impact-hub-logo {
    height: 49px;
    width: 49px;
    object-fit: cover;
  }

  #iamexpat-logo {
    height: 35px;
    width: 87px;
    object-fit: cover;
  }

  #founder-facts-logo {
    height: 35px;
    width: 141px;
    object-fit: cover;
  }

  @media (max-width: 740px) {
    .top-section {
      height: 300px;
      background-position: center 30%;
    }
    .intro-text {
      top: 186px;
    }

    .top-header {
      font-size: 60px;
      line-height: 68px;
    }

    .top-description {
      font-size: 20px;
      line-height: 28px;
      max-width: 300px;
    }

    .phone-screen-container {
      margin-top: 280px;
    }
    .graphic-card {
      padding: 920px 12px 60px;
    }

    /* .top-section {
      padding-right: 0px;
      padding-left: 0px;
    }
    .top-header {
      font-size: 28px;
    }

    .top-description {
      font-size: 18px;
    }

    .graphic-card,
    .values-card {
      p {
        font-size: 24px;
        line-height: 32px;
      }
    } */
  }

  @media (min-width: 1100px) {
    .top-section {
      background: url("https://res.cloudinary.com/table-sage/image/upload/c_scale,f_auto,q_auto:good,w_3072/v1632735770/ts-homepage/edited-home-banner_kfp1ez.jpg");
      background-size: cover;
      height: 600px;
      max-height: none;
      min-height: none;
      flex-direction: row;
      align-items: flex-end;
      justify-content: flex-start;
      padding: 0px 0 0 60px;
    }

    .intro-text {
      width: 50%;
      //set to same height as phone screen container and start both from the bottom, -60px for the -60px on phone screen
      height: calc(540px - 50px);
      position: relative;
      top: initial;
      margin-bottom: 0;
      align-items: flex-start;
      text-align: left;
    }

    .top-header {
      color: var(--off-black);
      font-size: 75px;
      line-height: 81px;
      padding-left: 0;
      margin-bottom: 20px;

      /* padding-left: 8px; */
      /* width: 400px; */
      /* max-width: 400px; */
    }

    .top-description {
      color: var(--off-black);
      font-size: 20px;
      line-height: 38px;
      padding-left: 4px;
      width: 420px;
      max-width: 420px;
      margin-bottom: 80px;

      span {
        //hack to apply background color to individual text lines
        box-shadow: 0 0 0 4px #fff;
        background-color: #fff;
        //fix firefox
        box-decoration-break: clone;
        line-height: 1.1;
        padding: 0 4px 0 4px;
        border: 1px solid white;
      }
    }

    /* .dine-well,
    .do-good {
      //hack to apply background color to individual text lines
      box-shadow: 0 0 0 8px #fff;
      background-color: #fff;
      //fix firefox
      box-decoration-break: clone;
      line-height: 38px;
      padding-top: 5px;
      border: 1px solid white;
    } */

    .phone-screen-container {
      width: 50%;
      height: 100%;
      flex-direction: column;
      align-items: center;
      justify-content: flex-end;
    }

    .phone-screen {
      position: relative;
      bottom: -60px;
      height: 540px;
      width: 275px;
    }

    .phone-bezel-and-vid {
      position: relative;
    }

    .phone-screen-video {
      background-color: var(--off-black);
      /* height: 508px;
      width: 246px;
      border-radius: 26px;
      position: absolute;
      left: 15px; */

      height: 510px;
      width: 231px;
      /* border-radius: 20px; */
      position: absolute;
      left: 22px;
      bottom: -39px;
    }

    .second-section {
      flex-direction: row;
    }

    .graphic-card,
    .process-card {
      height: 95vh;
      min-height: 700px;
      max-height: 900px;
      width: 50%;
      padding: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    .graphic-card {
      p {
        max-width: 350px;
      }
    }

    .point {
      max-width: 360px;
      text-align: left;
      display: flex;
      flex-direction: row;

      h2 {
        width: 40px !important;
        padding-right: 20px;
        margin: 0;
        text-align: center;
      }

      p {
        max-width: 315px;
        min-width: 315px;
        width: 315px !important;
      }
    }

    @keyframes fadein {
      0% {
        opacity: 0;
      }

      100% {
        opacity: 1;
        -webkit-transform: translateY(0);
        -moz-transform: translateY(0);
        -o-transform: translateY(0);
        -ms-transform: translateY(0);
        transform: translateY(0);
      }
    }

    @keyframes slideup {
      0% {
        -webkit-transform: translateY(10px);
        -moz-transform: translateY(10px);
        -o-transform: translateY(10px);
        -ms-transform: translateY(10px);
        transform: translateY(10px);
      }

      100% {
        -webkit-transform: translateY(0);
        -moz-transform: translateY(0);
        -o-transform: translateY(0);
        -ms-transform: translateY(0);
        transform: translateY(0);
      }
    }

    .animate-text#point-one {
      opacity: 0;
      transform: translateY(10px);
      -webkit-animation: slideup 2s linear forwards, fadein 1s ease forwards;
      -moz-animation: slideup 2s linear forwards, fadein 1s ease forwards;
      -o-animation: slideup 2s linear forwards, fadein 1s ease forwards;
      -ms-animation: slideup 2s linear forwards, fadein 1s ease forwards;
      animation: slideup 2s linear forwards, fadein 1s ease forwards;
    }

    .animate-text#point-two {
      opacity: 0;
      transform: translateY(10px);
      -webkit-animation: slideup 2s linear 1s forwards,
        fadein 1s ease 1s forwards;
      -moz-animation: slideup 2s linear 1s forwards, fadein 1s ease 1s forwards;
      -o-animation: slideup 2s linear 1s forwards, fadein 1s ease 1s forwards;
      -ms-animation: slideup 2s linear 1s forwards, fadein 1s ease 1s forwards;
      animation: slideup 2s linear 1s forwards, fadein 1s ease 1s forwards;
    }

    .animate-text#point-three {
      opacity: 0;
      transform: translateY(10px);
      -webkit-animation: slideup 2s linear 2s forwards,
        fadein 1s ease 2s forwards;
      -moz-animation: slideup 2s linear 2s forwards, fadein 1s ease 2s forwards;
      -o-animation: slideup 2s linear 2s forwards, fadein 1s ease 2s forwards;
      -ms-animation: slideup 2s linear 2s forwards, fadein 1s ease 2s forwards;
      animation: slideup 2s linear 2s forwards, fadein 1s ease 2s forwards;
    }

    .animate-text#about-process-btn {
      opacity: 0;
      -webkit-animation: fadein 0.7s linear 3s forwards;
      -moz-animation: fadein 0.7s linear 3s forwards;
      -o-animation: fadein 0.7s linear 3s forwards;
      -ms-animation: fadein 0.7s linear 3s forwards;
      animation: fadein 0.7s linear 3s forwards;
    }

    .third-section {
      height: 100vh;
      min-height: 700px;
      /* max-height: 1000px; */

      img {
        height: 100%;
        width: 100%;
        object-fit: cover;
      }
    }

    .image-text-box {
      max-width: 520px;
    }

    .text-over-image {
      justify-content: flex-start;
      align-items: center;
      background: linear-gradient(
        rgba(255, 255, 255, 0.85),
        rgba(255, 255, 255, 0.55) 30%,
        transparent 55%
      );

      p {
        font-size: 22px;
        line-height: 30px;
        margin-bottom: 16px;
        text-shadow: 0px 0px 15px white;

        &:last-child {
          margin-bottom: 40px;
        }
      }

      span {
        box-shadow: none;
        background-color: transparent;
        box-decoration-break: none;
        padding: 0;
        border: none;
      }
    }

    .fourth-section {
      flex-direction: row;
    }

    .impact-card,
    .values-card {
      width: 50%;
      height: 95vh;
      min-height: 700px;
      max-height: 900px;
      padding: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    .impact-card {
      text-align: left;

      p,
      h2 {
        max-width: 320px;
      }
    }

    .articles-section {
      h2 {
        max-width: 500px;
      }
      p {
        max-width: 480px;
      }
    }

    .partner-section {
      p {
        max-width: 520px;
      }
    }

    .featured-on {
      padding: 60px 0 80px 0;

      h2 {
        margin-bottom: 40px;
      }

      &-logo {
        margin-bottom: 0;
        margin-right: 52px;

        &:last-child {
          margin-right: 0;
        }
      }
    }

    .logos {
      flex-direction: row;
    }
  }

  @media (min-width: 1300px) {
    .top-section {
      height: 720px;
      max-height: none;
      min-height: none;
    }

    .intro-text {
      //set to same height as phone screen container and start both from the bottom, -70px for the -70px on phone screen, -10px for white box shadow (text bg color);
      height: calc(638px - 50px);
    }

    .top-header {
      font-size: 80px;
      line-height: 86px;
      padding-left: 0px;
      /* width: 400px; */
      /* max-width: 400px; */
    }

    .top-description {
      font-size: 22px;
      line-height: 40px;
      padding-left: 4px;
      width: 470px;
      max-width: 470px;
      margin-bottom: 80px;
    }

    .phone-screen {
      position: relative;
      bottom: -70px;
      height: 648px;
      width: 330px;
    }
    .phone-screen-video {
      background-color: var(--off-black);
      /* height: 508px;
      width: 246px;
      border-radius: 26px;
      position: absolute;
      left: 15px; */

      height: 612px;
      width: 277.2px;
      /* border-radius: 20px; */
      position: absolute;
      left: 26.4px;
      bottom: -45px;
    }
  }
`;

export default HomeStyles;
